<template>
  <div>
    <page-heading heading="Встречи 1:1">
      <span slot="right">
        <el-button
          type="primary"
          size="small"
          icon="fas fa-plus"
          @click="$refs.editDialog.open()"
        >
          Создать встречу
        </el-button>
      </span>
    </page-heading>

    <el-card>
      <meetings-list ref="list" />
    </el-card>

    <meeting-edit-dialog
      ref="editDialog"
      @saved="$refs.list.loadMeetings()"
    />
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading.vue";
import MeetingsList from "@/modules/oneToOne/components/meetings/MeetingsList.vue";
import MeetingEditDialog from "@/modules/oneToOne/components/meetings/MeetingEditDialog.vue";

export default {
  name: 'OneToOneMeetings',
  components: { PageHeading, MeetingsList, MeetingEditDialog },
};
</script>